/**
 * @since 0.1.1
 */
import { z } from 'zod';

/**
 * @since 0.1.1
 * @category extrasSchema
 */
export const extrasSchema = z.record(z.any());
